import { render, staticRenderFns } from "./lang.vue?vue&type=template&id=655586c2&scoped=true"
import script from "./lang.vue?vue&type=script&lang=js"
export * from "./lang.vue?vue&type=script&lang=js"
import style0 from "./lang.vue?vue&type=style&index=0&id=655586c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655586c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655586c2')) {
      api.createRecord('655586c2', component.options)
    } else {
      api.reload('655586c2', component.options)
    }
    module.hot.accept("./lang.vue?vue&type=template&id=655586c2&scoped=true", function () {
      api.rerender('655586c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/static/header/lang.vue"
export default component.exports